const Role = {
    MAIN_USER: 'MAIN_USER',
    ADMINISTRATOR: 'ADMINISTRATOR',
    TEAM_HEAD: 'TEAM_HEAD',
    TEAM: 'TEAM',
    TRAINER: 'TRAINER',
    ATHLETE: 'ATHLETE',
    GUEST: 'GUEST'
};

export default Role;
